import { useScrollReveal } from "@/hooks/useScrollReveal";
import HeroSection from "./components/HeroSection";
import StickyNavSection from "./components/StickyNavSection";
import AboutNobleLaboSection from "./components/AboutNobleLaboSection";
import WhyStartedSection from "./components/WhyStartedSection";
import MessageSupportSection from "./components/MessageSupportSection";
import OurDXViewSection from "./components/OurDXViewSection";
import PrinciplesSection from "./components/PrinciplesSection";
import IntegratedBusinessSection from "./components/IntegratedBusinessSection";
import NameMeaningSection from "./components/NameMeaningSection";
import CompanySection from "./components/CompanySection";
import ContactCTASection from "./components/ContactCTASection";

export default function AboutPage() {
  useScrollReveal();

  return (
    <>
      <HeroSection />
      <StickyNavSection />
      <AboutNobleLaboSection />
      <WhyStartedSection />
      <MessageSupportSection />
      <OurDXViewSection />
      <PrinciplesSection />
      <IntegratedBusinessSection />
      <NameMeaningSection />
      <CompanySection />
      <ContactCTASection />
    </>
  );
}